<div class="calendar-container">
  <div class="d-flex gap-2 align-items-center mb-2">
    <div class="fs-5 fw-semibold">
      {{ currentMonthName() }} {{ currentYear() }}
    </div>
    <div
      (click)="previousMonth()"
      class="bg-white border text-dark text-center rounded text-center d-flex align-items-center date-select-button flex-grow-1 d-flex justify-content-center p-2"
      role="button"
    >
      <i class="fas fa-angle-left"></i>
    </div>

    <div
      (click)="nextMonth()"
      class="bg-white border text-dark text-center rounded text-center d-flex align-items-center date-select-button flex-grow-1 d-flex justify-content-center p-2"
    >
      <i class="fas fa-angle-right"></i>
    </div>

    <div
      (click)="goToToday()"
      class="bg-white border text-dark text-center rounded text-center d-flex align-items-center date-select-button small fw-medium p-2"
      role="button"
    >
      Today
    </div>
  </div>
  <div class="weekdays-grid">
    @for (day of weekDays; track day) {
      <div class="weekday-label">{{ day }}</div>
    }
  </div>

  <div class="days-grid">
    @for (cell of calendarCells(); track cell.date.toISOString()) {
      <div
        class="day-cell"
        [class.opacity-50]="
          (today | customDate: 'MMM y') != (cell.date | customDate: 'MMM y')
        "
        [class.text-success]="selectedDates.has(cell.date | date: 'd MMM y')"
        (click)="selectDate(cell.date)"
      >
        <div
          class="day-number"
          [class.fw-bold]="
            (today | customDate: 'd MMM y') ==
            (cell.date | customDate: 'd MMM y')
          "
        >
          {{ cell.date | customDate: "d" }}
        </div>
      </div>
    }
  </div>
</div>
